<template>
  <div id="gradecard" class="ticket1 flex jc-center">
    <div class="tk-line2">
      <div class="tk-logo mt-8">
        <img class="tkl-img" :src="collegeLogoUrl" crossorigin="anonymous">
        <div class="tkl-names">
          {{ detail.resultTitle || detail.collegeName }}
        </div>
      </div>
      <div class="pb-8 pt-8">
        <div class="border-line"></div>
      </div>
      <div class="flex jc-between mb-8">
        <div style="flex: 1;">
          <div class="name mb-8">{{ detail.examineeName }}</div>
          <template v-for="item in personInfoList">
            <div :key="`${item.code}${item.subCode}`" class="custom cm-tip">
              <div class="cm-label font-10">{{ item.name }}</div>
              <div class="brake-all cm-content font-10">{{ item.value }}</div>
            </div>
          </template>
          <!-- <div class="custom cm-tip">
            <div class="cm-label">身份证号</div>
            <div class="brake-all cm-content">{{detail.examineeIdNo}}</div>
          </div> -->
        </div>
        <img class="txl-photo ml-8" :src="imgUrls" crossorigin="anonymous">
      </div>
      <div class="custom cm-tip circle-tip">
        考试专业【{{ detail.specialtyName }}】
        <!-- 报考专业【{{detail.guideSpecialtyName}}{{detail.guideBranchName ? '-' + detail.guideBranchName : ''}}】 -->
      </div>
      <van-row class="border-t border-l" type="flex">
        <template v-for="item in guideInfoList">
          <van-col :key="`${item.code}${item.subCode}`" class="border-b border-r" style="flex:1;" span="">
            <div class="tb-cell">
              {{ item.name }}
              <span class="text-blod">{{ item.value }}</span>
            </div>
          </van-col>
        </template>
        <!-- <van-col class="border-b border-r" style="flex:1;" span="">
          <div class="tb-cell">
            专业总分
            <span class="text-blod">83.6</span>
          </div>
        </van-col> -->
        <template v-for="item in guideExtra">
          <van-col :key="`${item.code}${item.subCode}`" class="border-b border-r" span="24">
            <div class="tb-cell tb-line">{{ item.value }}</div>
          </van-col>
        </template>
        <!-- <van-col class="border-b border-r" span="24">
          <div class="tb-cell tb-line">附加字段：请保存个人成绩</div>
        </van-col> -->
      </van-row>
      <div class="custom cm-tip circle-tip mt-16 mb-8">
        成绩详情
      </div>
      <van-row class="border-t border-l mb-8" type="flex">
        <van-col class="border-b border-r" span="12">
          <div class="tb-cell">科目</div>
        </van-col>
        <!--        <van-col class="border-b border-r" span="6">-->
        <!--          <div class="tb-cell">权重</div>-->
        <!--        </van-col>-->
        <van-col class="border-b border-r" span="12">
          <div class="tb-cell">成绩</div>
        </van-col>

        <template v-for="item in resultInfoList">
          <van-col :key="`${item.code}${item.subCode}_1`" class="border-b border-r" span="12">
            <div class="tb-cell">{{ item.name }}</div>
          </van-col>
          <!--<van-col :key="`${item.code}${item.subCode}_2`" class="border-b border-r" span="6">-->
          <!--  <div class="tb-cell">{{ item.weight }}%</div>-->
          <!--</van-col>-->
          <van-col :key="`${item.code}${item.subCode}_3`" class="border-b border-r" span="12">
            <div class="tb-cell">{{ item.value }}</div>
          </van-col>
        </template>

        <!-- <van-col class="border-b border-r" span="12">
          <div class="tb-cell">练耳</div>
        </van-col>
        <van-col class="border-b border-r" span="6">
          <div class="tb-cell">0%</div>
        </van-col>
        <van-col class="border-b border-r" span="6">
          <div class="tb-cell">87</div>
        </van-col> -->
        <template v-for="item in resultExtra">
          <van-col :key="`${item.code}${item.subCode}`" class="border-b border-r" span="24">
            <div class="tb-cell tb-line">{{ item.value }}</div>
          </van-col>
        </template>
        <!-- <van-col class="border-b border-r" span="24">
          <div class="tb-cell tb-line">考生名次已按乐器方向分别排序：女生中第45名，2人并列</div>
        </van-col> -->
      </van-row>
      <div class="brake-all">
        <div v-if="detail.certificateExtraContent" class="hege-cell">
          {{ detail.certificateExtraContent }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {Col, Row, Toast} from 'vant'
import Watermark from './watermark'

export default {
  props: ['detail'],
  components: {
    [Col.name]: Col,
    [Row.name]: Row,
  },
  data() {
    return {
      imgUrls: require('../../../static/img_ktx.png'),
      collegeLogoUrl: '',
    }
  },
  computed: {
    jsonMap() {
      return this.detail.jsonMap
    },
    personInfoList() {
      const arr = this.detail?.examineeListSubjectReportCardInfoJson?.personInfoList || []
      return arr.filter(v => v.value)
    },
    guideInfoList() {
      // code 201 是专业附加信息
      const arr = this.detail?.examineeListSubjectReportCardInfoJson?.guideInfoList || []
      return arr.filter(v => v.code !== '201' && v.value)
    },
    resultInfoList() {
      // code 301 是成绩附加信息
      const arr = this.detail?.examineeListSubjectReportCardInfoJson?.resultInfoList || []
      return arr.filter(v => v.code !== '301' && v.value)
    },
    guideExtra() {
      // code 201 是专业附加信息
      const arr = this.detail?.examineeListSubjectReportCardInfoJson?.guideInfoList || []
      return arr.filter(v => v.code === '201' && v.value)
    },
    resultExtra() {
      // code 301 是成绩附加信息
      const arr = this.detail?.examineeListSubjectReportCardInfoJson?.resultInfoList || []
      return arr.filter(v => v.code === '301' && v.value)
    },
  },
  created() {
    this.getFormatLogo()
  },
  mounted() {
    new Watermark({mark: this.detail?.waterMark || this.detail.examineeName, container: document.getElementById('gradecard'), height: 50})
    // Watermark.set({str: this.detail.examineeName, dom: document.getElementById('gradecard')})
  },
  methods: {
    async getFormatLogo() {
      Toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      })
      try {
        if (this.detail.officialPhoto) {
          this.imgUrls = await this.getImgBase64(this.detail.officialPhoto)
        }
        this.collegeLogoUrl = await this.getImgBase64(
            this.detail.collegeLogoUrl + '?' + Date.now()
        )
        Toast.clear()
      } catch (error) {
        Toast.clear()
      }
    },
    image2Base64(img) {
      var canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      var ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0, img.width, img.height)
      var dataURL = canvas.toDataURL('image/png')
      return dataURL
    },
    getImgBase64(image) {
      return new Promise((resolve, reject) => {
        var img = new Image()
        img.crossOrigin = '*'
        img.src = image
        img.onload = () => resolve(this.image2Base64(img))
        img.onerror = reject
      })
    },
  },
}
</script>
<style lang="less" scoped>
// 合格证
.ticket1 {
  width: 100%;
  min-height: 520px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 4px 24px rgba(0, 18, 54, 0.06);
  position: relative;
  border: 1px solid #d9d9d9;
  // background-size: 100% 100%;
  // background-image: url(../../../static/bg_subject.png);
  word-break: break-word;
  /* /n换行兼容 */
  white-space: pre-wrap;
}

.ticket1::after {
  content: '';
  width: calc(100% - 20px);
  height: calc(100% - 20px);
  position: absolute;
  left: 10px;
  top: 10px;
  border: 2px solid rgba(38, 68, 113, 0.2);

}

.ticket1::before {
  content: '';
  width: calc(100% - 30px);
  height: calc(100% - 30px);
  position: absolute;
  left: 15px;
  top: 15px;
  border: 2px solid #264471;
}

.bgimg {
  width: 100%;
  height: 100%;
}

.tk-line2 {
  // position: absolute;
  // left: 0;
  // top: 0;
  // width: 100%;
  // height: 100%;
  z-index: 10;
  padding: 20px 24px;
}

.tk-logo {
  display: flex;
  justify-content: center;
  align-items: center;

  .tkl-img {
    width: 30px;
    height: 30px;
    border-radius: 100%;
  }
}

.tkl-names {
  flex: 1;
  display: flex;
  align-items: center;
  word-break: break-all;
  padding: 4px 10px;
  font-weight: 600;
  // color: #FDFCFA;
}

.border-line {
  width: 100%;
  height: 1px;
  background: #CECECE;
}

.txl-photo {
  width: 90px;
  height: 120px;
  // height: 129px;
  background: #f5f5f5;
  border-radius: 4px;
  object-fit: contain;
}

.name {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 600;
  color: #264471;
}

.custom {
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #434345;
}

.cm-tip {
  display: flex;
  margin-bottom: 4px;
  word-break: break-all;
}

.cm-label {
  // width: 50px;
  width: 4.5em;
  line-height: 1.6em;
}

.cm-content {
  flex: 1;
  line-height: 1.6em;
}

.gp-text {
  font-size: 10px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 16px;
  color: #434345;
}

.hege-cell {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 14px;
  min-height: 38px;
  font-family: PingFang SC;
  color: #434345;
}

.circle-tip {
  position: relative;
  font-size: 14px;
  font-weight: 600;
  text-indent: 1em;
}

.circle-tip::after {
  position: absolute;
  left: 0;
  top: 5.5px;
  content: '';
  width: 6px;
  height: 6px;
  border: 2px solid #00A7FF;
  border-radius: 50%;
}

.tb-cell {
  font-size: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 30px;
  text-align: center;
  word-break: break-all;
  padding: 3px 5px;
  color: #434345;
}

.text-blod {
  font-size: 14px;
  font-weight: 600;
  color: #000;
}

.tb-line {
  align-items: normal;
  text-align: left;
}

.border-t {
  border-top: 1px solid #CECECE;
}

.border-b {
  border-bottom: 1px solid #CECECE;
}

.border-l {
  border-left: 1px solid #CECECE;
}

.border-r {
  border-right: 1px solid #CECECE;
}
</style>
